import { createSlice } from "@reduxjs/toolkit";
import { User } from "../types";

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthReady: boolean;
}

const initialState: AuthState = {
  user: null,
  token: null,
  isAuthReady: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthReady = true;
    },
    clearAuth: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthReady = false;
    },
  },
});

export const { setAuth, clearAuth } = authSlice.actions;
export default authSlice.reducer;
